import React from 'react'

import { style } from '../../../../components/Common/Index.style'
import Page from '../../../../components/Page/Page'
import PageHeader from '../../../../components/PageHeader/PageHeader'
import Content from '../../../../components/Content/Content'
import SectionTitle from '../../../../components/SectioinTitle'
import BackBtn from '../../../../components/Common/BackBtn'
import BreadCrumb from '../../../../components/Breadcrumbs/Breadcrumbs'




const pageTitle = 'みなさんの声を県政に | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="" />
      <SectionTitle sectionTitle="みなさんの声を県政に" />
      <Content css={style.content}>
        <BreadCrumb
          lists={[
            {
              name: "HOME",
              path: "/"
            },
            {
              name: "2025冬号 No.169 目次",
              path: "/no169"
            },
            {
              name: "みなさんの声を県政に"
            }
          ]}
        />
        <h3 css={style.subTitle01}>知事へのたより</h3>
        <p>広く県民の皆さんから県政についての建設的なご意見やご提言をお寄せいただくため、「知事へのたより」専用はがきを用意しています。</p>

        <h4 css={style.subTitle02}>設置場所&emsp;市町村役場・県地域振興局など</h4>
        <p>電子メール：<a href="mailto:kouchou@pref.niigata.lg.jp">kouchou@pref.niigata.lg.jp</a></p>
        <p>ファックス：025-280-5049でも受付</p>

        <h3 css={style.subTitle01}>県民相談室</h3>
        <p>県庁行政庁舎1階の県民相談室では、専任の職員が皆さんからの県政への相談、苦情、意見・提言に応じています。</p>

        <p>電話：<a href="tel:025-280-5076">025-280-5076</a></p>
        <p>電子メール：<a href="mailto:info@pref.niigata.lg.jp">info@pref.niigata.lg.jp</a></p>

        <BackBtn href={"/no169"} />
      </Content>
    </Page>
  )
}
export default Home
